var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "w-full max-w-xs mdmax:w-full mb-6"
  }, [_c('div', {
    staticClass: "date-range relative text-xs shadow-sm"
  }, [_c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2 z-1"
  }, [_c('Calendar', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('date-range-picker', {
    attrs: {
      "locale-data": {
        format: 'dd/mm/yyyy',
        separator: ' - '
      },
      "showDropdowns": false,
      "timePicker": false,
      "timePicker24Hour": false,
      "ranges": false
    },
    on: {
      "update": _vm.setDate
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1)]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('LinkButton', {
          attrs: {
            "buttonText": "Lihat rincian",
            "url": `/invoice/detail/${entry.id}`,
            "linkType": "internal",
            "type": "secondary",
            "size": "small"
          }
        }) : column.field === 'created_at' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(_vm._f("formatDate")(entry[column.field])) + " ")]) : column.field === 'id' ? _c('span', {
          staticClass: "block break-all"
        }, [_vm._v(" " + _vm._s(entry[column.field]) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }